import { CompanyDriverDeliveries } from "modules/companyAdmin";

const CompanyAdminDriverDeliveriesPage = () => <CompanyDriverDeliveries />;

export default CompanyAdminDriverDeliveriesPage;
